module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "600",
      "min-width": "600",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-details": "",
      "hide-overlay": false,
      "retain-focus": false,
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('v-card', {
    ref: "dialogDOM",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0",
    staticStyle: {
      "flex-grow": "0"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.settings.title || 'Select'))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("header")], 2)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "5px",
      "flex-grow": "1",
      "display": "flex"
    },
    style: (_vm.bodyStyle)
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "scroll",
      "height": "100%"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', [_vm._t("sidebar")], 2)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "flex-grow": "0",
      "padding": "10px"
    }
  }, [_c('div', [_vm._t("footer")], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.settings.closeOnly) ? [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.settings.cancelLabel || 'Cancel'))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.settings.saveLabel || 'Save'))])] : _vm._e(), _vm._v(" "), (_vm.settings.closeOnly) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v("Close")]) : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e81e058"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/DialogBox.vue
// module id = 2517
// module chunks = 1